import React from 'react';
import styled from 'styled-components';
import { negativeMedium } from '@zocdoc-mezzanine/foundations-colors';
import { labelExtraSmall } from '@zocdoc-mezzanine/foundations-typography';

/**
 * FormErrorMessage
 * Error message used by form elements. If no message is passed in, nothing is rendered.
 * Styles and spacing included.
 * @param {string} [invalidMessage] - Error message. If null or empty, no error message will render.
 * @param {string} [dataTest] - value for the data test attribute strings to the component.
 * @returns {JSX.Element} FormErrorMessage
 */
const FormErrorMessage = ({ invalidMessage, 'data-test': dataTest }) => {
    return (
        !!invalidMessage?.trim()?.length && (
            <ErrorMessage data-test={dataTest} aria-live="polite">
                {invalidMessage}
            </ErrorMessage>
        )
    );
};

const ErrorMessage = styled.p`
    ${labelExtraSmall};
    color: ${negativeMedium};
    margin-top: 4px;
    margin-left: 0px;
`;

export default FormErrorMessage;
